(function($) {

  //
  // Gutenberg block
  //

  const $block_swiper = $('.block-imagecarousel');
  if( $block_swiper.length ) {

    const swiper =   new Swiper('.block-imagecarousel .swiper-container', {
      grabCursor: true,
      spaceBetween: 0,
      slidesPerView: 'auto',
      autoHeight: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        576: {
          spaceBetween: 0,
        },
        1024: {
          spaceBetween: 0,
        },
        1400: {
          spaceBetween: 30,
        },
        1500: {
          spaceBetween: 40,
        },
      }
    });
  }

  //
  // Mixed media block
  //

  const $block_media_swiper = $('.block-mixed-media-carousel');
  if( $block_media_swiper.length ) {

    const swiper =   new Swiper('.block-mixed-media-carousel .swiper-container', {
      grabCursor: true,
      spaceBetween: 0,
      slidesPerView: 'auto',
      autoHeight: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        576: {
          spaceBetween: 0,
        },
        1024: {
          spaceBetween: 0,
        },
        1400: {
          spaceBetween: 30,
        },
        1500: {
          spaceBetween: 40,
        },
      }
    });
  }


  //
  // Gutenberg block
  //

  const $block_ship_swiper = $('.block-ship-carousel');
  if( $block_ship_swiper.length ) {

    const swiper = new Swiper('.block-ship-carousel .swiper-container', {
      slidesPerView: 1.25,
      spaceBetween: 15,
      grabCursor: true,
      freeMode: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        576: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1.75,
        },
        1024: {
          slidesPerView: 2.5,
        },
        1200: {
          slidesPerView: 3.25,
        },
        1400: {
          slidesPerView: 2.75,
        },
        // 1700: {
        //   slidesPerView: 4.25,
        // },
      }
    });
  }

   //
  // Single ship Carrousels
  //

  const $ship_swiper = $('.ship-swiper');
  if( $ship_swiper.length ) {

    const swiper = new Swiper('.ship-swiper', {
      slidesPerView: 1,
      grabCursor: true,
      freeMode: false,
      spaceBetween: 400,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // 576: {
        //   slidesPerView: 1.5,
        // },
        // 768: {
        //   slidesPerView: 2.5,
        // },
        // 1024: {
        //   slidesPerView: 2.5,
        // },
        // 1200: {
        //   slidesPerView: 3.25,
        // },
        // 1400: {
        //   slidesPerView: 3.25,
        // },
        // 1700: {
        //   slidesPerView: 4.25,
        // },
      }
    });
  }

  //
  // Vertical Carrousels
  //

  const $vertical_swiper = $('.block__vertical-carousel');
  if( $vertical_swiper.length ) {

    const vertical_swiper = new Swiper('.block__vertical-carousel .swiper-container', {
      slidesPerView: 1,
      direction: 'vertical',
      keyboard: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        init: function () {
          let slide = this.slides[this.activeIndex];
          let dataIndex = slide.getAttribute('data-index');
          $('.block__vertical-carousel .active').removeClass('active');
          $('.block__vertical-carousel [data-index='+dataIndex+']').addClass('active');
        },
        slideChange: function () {
          let slide = this.slides[this.activeIndex];
          let dataIndex = slide.getAttribute('data-index');
          $('.block__vertical-carousel .active').removeClass('active');
          $('.block__vertical-carousel [data-index='+dataIndex+']').addClass('active');
        }
      },
      breakpoints: {
        // 576: {
        //   slidesPerView: 1.5,
        // },
        // 768: {
        //   slidesPerView: 2.5,
        // },
        // 1024: {
        //   slidesPerView: 2.5,
        // },
        // 1200: {
        //   slidesPerView: 3.25,
        // },
        // 1400: {
        //   slidesPerView: 3.25,
        // },
        // 1700: {
        //   slidesPerView: 4.25,
        // },
      }
    });

    $('.block__vertical-carousel span[data-index]').on('click', function(e) {
      let $this = $(this);
      let dataIndex = $this.attr('data-index');
      // let slide = $('.block__vertical-carousel .swiper-slide[data-index='+dataIndex+']');
      // var selectedSlideIndex = vertical_swiper.slides.index(slide);
      // console.log( selectedSlideIndex);
      vertical_swiper.slideTo( dataIndex );
    });


  }

})(jQuery);